

export default {
    logging: false,
    baseURL: '/api',
    version: 'v1.0.1',//v1.0.30
    timerAlertCountdown: '120',
    Crypto: {
        ECDH: {
            PublicKeyB:
                'BAD1Fc9PG29SdYLnwP1qb3Tl8J+NAB2+XcofH3sUKqL/amZ7c1mXZINJkVJY+ifm93N+FV9N/mPmzTUacOXlXvn1NgHYRq3s00mrD6mNToJOM5MXSDdHdSwFeoIsOfA7FGU1ICce1lYQ4MeHoCiv0TJHm4iCYVLahOe8jXtrm+5NAaFfqQ=='
        }
    },
    fileUrl:"/api/file/",
    publicFileUrl:"api/file/public/",
    feedPortalUrl:"https://md1-dev.finext.com.my",
    headerLogo:"/img/FiNext/traderstation-logo.png"
};
